import { render } from "./WorkshopSection.vue?vue&type=template&id=36dfbb08&scoped=true"
import script from "./WorkshopSection.vue?vue&type=script&lang=js"
export * from "./WorkshopSection.vue?vue&type=script&lang=js"

import "./WorkshopSection.vue?vue&type=style&index=0&id=36dfbb08&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36dfbb08"]])

export default __exports__